import React from 'react';

const SelectLoadingIndicator = () => (
  <div className="mr-2">
    <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-400 border-t-transparent" />
  </div>
);

export default SelectLoadingIndicator;
